import { defineMessages } from 'react-intl'

/* eslint-disable max-len */

export default defineMessages({
  heroTitle: 'Integration of Content Management, CRM, and Web Services',
  name: 'Mitsubishi Factory Automation',
  heroDescription: 'As an EMEA-wide company with an extensive product range, Mitsubishi Electric Factory Automation’s web platform serves as a key touchpoint for visitors from diverse markets and industries.'
})
